import Alert from "../components/Alert";

export default function Complete({ text }) {
	return <Alert data={{ type: "success", text }} />;
}
